// Use $ instead of $ without replacing global $
(function ($) {
  $(document).ready(function () {
    $(".quote-slider .slider-for").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: ".slider-nav",
    });
    $(".quote-slider .slider-nav").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: ".slider-for",
      dots: false,
      focusOnSelect: true,
    });
  });
})(jQuery);
